import {getApiService} from '../services/HttpService';
import Api from 'constants/Api';

export const TRADE_CONSTANTS = {
    GET_MARKETS: 'TRADE_GET_MARKETS',
    GET_OPEN_TRADES: 'GET_OPEN_TRADES',
    MARKET_PRICES: 'SET_MARKET_PRICES',

    FAILURE: 'TRADE_FAILURE',
    RESET: 'TRADE_RESET',
};

const getMarketsRequest = payload => ({
    type: TRADE_CONSTANTS.GET_MARKETS,
    payload
});
const getOpenTrades = payload => ({
    type: TRADE_CONSTANTS.GET_OPEN_TRADES,
    payload
});
export const handleFailure = payload => ({
    type: TRADE_CONSTANTS.FAILURE,
    payload
});

export const handleGetMarkets = (payload, token = null) => async dispatch => {
    const _ = require('lodash');
    const markets_request = await getApiService(Api.TRADING_GET_MARKETS, payload, token);
    const markets_soon_request = await getApiService(Api.TRADING_GET_MARKETS_SOON, payload, token);

    let marketsBySymbol = {};
    let marketsById = {};
    let marketsSoon = [];
    let fiatMarket = [];
    let pairMarket = [];
    let markets = [];

    if (markets_request.success === false) {
        dispatch(handleFailure(markets_request))
    } else {
        let {data: markets_data} = markets_request;
        if (markets_data.results.length > 0) {
            let retrieveMarkets = _.sortBy(markets_data.results, ['pk']);
            retrieveMarkets.forEach((item) => {
                let [marketFrom, marketTo] = item.market.split('/');
                marketFrom = marketFrom.split('|');
                marketTo = marketTo.split('|');

                let marketBaseInfo = {
                    pk: item.pk,
                    market: `${marketFrom[0]}/${marketTo[0]}`,
                    from: marketFrom,
                    to: marketTo,
                    platform_type: item.platform_type,
                    min_trade: item.min_trading
                }

                /**
                 * Store market by symbol name
                 * @type {{[p: string]: {market: string, from: string[], pk: *, to: string[]}}}
                 */
                marketsBySymbol = {
                    ...marketsBySymbol,
                    [marketFrom[1] + '_' + marketTo[1]]: marketBaseInfo
                };

                marketsById = {
                    ...marketsById,
                    [item.pk]: marketBaseInfo
                };

                markets.push(marketBaseInfo);

                if (marketTo[1] === 'IRT') {
                    fiatMarket.push(marketBaseInfo)
                } else {
                    pairMarket.push(marketBaseInfo)
                }
            });
        }
    }

    if (markets_soon_request.success === false) {
        // Nothing about soon markets
    } else {
        let {data: markets_soon_data} = markets_soon_request;
        if (markets_soon_data.results.length > 0) {
            let retrieveMarkets = _.sortBy(markets_soon_data.results, ['pk']);
            retrieveMarkets.forEach((item) => {
                let [marketFrom, marketTo] = item.market.split('/');
                marketFrom = marketFrom.split('|');
                marketTo = marketTo.split('|');

                let marketBaseInfo = {
                    pk: item.pk,
                    market: `${marketFrom[0]}/${marketTo[0]}`,
                    from: marketFrom,
                    to: marketTo,
                    platform_type: item.platform_type,
                    min_trade: item.min_trading
                }

                /**
                 * Store market by symbol name
                 * @type {{[p: string]: {market: string, from: string[], pk: *, to: string[]}}}
                 */
                marketsBySymbol = {
                    ...marketsBySymbol,
                    [marketFrom[1] + '_' + marketTo[1]]: marketBaseInfo
                };

                marketsById = {
                    ...marketsById,
                    [item.pk]: marketBaseInfo
                };

                marketsSoon.push(marketBaseInfo);
                markets.push(marketBaseInfo);

                if (marketTo[1] === 'IRT') {
                    fiatMarket.push(marketBaseInfo)
                } else {
                    pairMarket.push(marketBaseInfo)
                }
            });
        }
    }

    dispatch(getMarketsRequest({
        markets: markets,
        pairMarket: pairMarket,
        fiatMarket: fiatMarket,
        marketsSoon: marketsSoon,
        marketsBySymbol: marketsBySymbol,
        marketsById: marketsById
    }))
};

export const handleGetOpenTrades = (payload, token = null) => async dispatch => {
    const request = await getApiService(Api.TRADING_GET_OPEN_REQUESTS, payload, token);

    if (request.success === false) {
        dispatch(handleFailure(request))
    } else {
        let {data} = request;
        dispatch(getOpenTrades(data.results.trading))
    }
};

export const handleSetMarketPrices = (payload) => async dispatch => {
    dispatch({
        type: TRADE_CONSTANTS.MARKET_PRICES,
        payload
    })
};

export const handleReset = () => ({
    type: TRADE_CONSTANTS.RESET
});